"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _ark = require("@dateam/ark");
var _CalendarHeader = _interopRequireDefault(require("./CalendarHeader"));
var _CalendarBody = _interopRequireDefault(require("./CalendarBody"));
const Calendar = _ref => {
  let {
    date,
    minDate,
    maxDate,
    className,
    onSelect
  } = _ref;
  const [internalDate, setInternalDate] = (0, _arkReact.useInternalValue)(date ?? new Date());
  const [displayedDate, setDisplayedDate] = (0, _arkReact.useInternalValue)(internalDate);
  const selectDate = _react.default.useCallback((date, event) => {
    if (!(0, _ark.isValidDate)(date)) return;
    setInternalDate(date);
    if ((0, _ark.isFunction)(onSelect)) onSelect(date, event);
  }, [onSelect, setInternalDate]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)('calendar', className)
  }, /*#__PURE__*/_react.default.createElement(_CalendarHeader.default, {
    date: displayedDate,
    onChange: setDisplayedDate
  }), /*#__PURE__*/_react.default.createElement(_CalendarBody.default, {
    date: displayedDate,
    dateSelected: internalDate,
    onSelect: selectDate,
    minDate: minDate,
    maxDate: maxDate
  }));
};
process.env.NODE_ENV !== "production" ? Calendar.propTypes = {
  date: _propTypes.default.instanceOf(Date),
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  className: _propTypes.default.string,
  onSelect: _propTypes.default.func
} : void 0;
Calendar.defaultProps = {
  date: undefined,
  minDate: undefined,
  maxDate: undefined,
  className: undefined,
  onSelect: undefined
};
var _default = exports.default = Calendar;